import { render, staticRenderFns } from "./taxgift.vue?vue&type=template&id=69ba26db&scoped=true&"
import script from "./taxgift.vue?vue&type=script&lang=js&"
export * from "./taxgift.vue?vue&type=script&lang=js&"
import style0 from "./taxgift.vue?vue&type=style&index=0&id=69ba26db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ba26db",
  null
  
)

export default component.exports